<div class="units-graph">
  <div class="mat-subheading-2" fxLayout fxLayoutGap="4px" fxLayoutAlign="start cetner">
    <mat-icon>insert_chart_outlined</mat-icon>
    <div>
      <span>アルバム換算数</span>
    </div>
    <mat-icon
      class="help"
      matTooltip="上部カレンダーで期間指定された範囲のアルバム換算値【ダウンロード数、ストリーム数（速報値）、フィジカル消化数（実売数）】をグラフ化しています。"
      >help_outline</mat-icon
      ><app-csv-download
      [id]="csvId"
      [fileName]="csvFileName"
      [csv]="csvData$ | async"
      [loading]="isLoading$ | async"
      [artist]="selectedArtist$ | async"
    ></app-csv-download>
  </div>
  <mat-card>
    <mat-card-content>
      @if (subAccounts$ | async; as labels) {
      <div fxLayout
           fxLayout="column"
           fxFlex="1 1 auto"
           fxLayoutAlign="start stretch"
           class="container"
           (window:resize)="onResize()"
           #container>
        @if (!(isLoading$ | async)) {
        @if (!media.isActive('lt-md')) {
        <section class="checkbox-section">
          @for (checkLabel of checkLabels; track checkLabel) {
          <mat-checkbox class="checkbox-margin"
                        [(ngModel)]="checkLabel.completed"
                        (ngModelChange)="onChange()"
                        [disabled]="checkLabel.disabled"
                        color="primary">{{ checkLabel.name }}</mat-checkbox>
          }
        </section>
        }
        @if (units$ | async; as data) {
        <div fxFlex="1 1 auto" class="div-chart">
          @if (data.length > 0) {
          <google-chart #chart
                        class="chart"
                        type="LineChart"
                        [height]="300"
                        [data]="data"
                        [columns]="labels"
                        [options]="unitsOptions"
                        [dynamicResize]="false"
                        (select)="onSelect($event)">
          </google-chart>
          }
        </div>
        }
        } @else {
        <app-music-note></app-music-note>
        }
      </div>
      }
      @if (!(dataCollectLoading$ | async)) {
      @if (!(dataCollections$ | async)) {
      <img class="datanofix_icon" src="./assets/data_collections.png" />
      } @else {
      <img class="datafix_icon"
           matTooltip="各項目において選択した期間のデータが全部揃っている場合に、チェックマークが表示されます。"
           src="./assets/data_collections.png" />
      }
      } @else {
      <img class="datanofix_icon" src="./assets/data_collections.png" />
      }
    </mat-card-content>
  </mat-card>
    </div>



